<div class="center-xy">
    <loader [dark]="true" *ngIf="!hasSubtitles"></loader>
</div>
